export const aspectRatioMapping = {
    '16-9': 16 / 9,
    '9-16': 9 / 16,
    '4-3': 4 / 3,
    '3-4': 3 / 4,
    '3-2': 3 / 2,
    '1-1': 1 / 1,
    none: 1
};
//# sourceMappingURL=aspect-ratio.js.map